import React, { useRef } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { useForm } from 'react-hook-form';
import { Input } from 'components/formInputs/input';
import { FormDialog } from 'components/dialogs/formDialog';

export const ResetPasswordForm = ({ isOpen, closeModal, onSave }) => {
  const schema = yup.object().shape({ email: yup.string().required() });

  const cancelButtonRef = useRef(null);

  const {
    register,
    handleSubmit,
    reset,
  } = useForm({
    defaultValues: schema.default(),
    resolver: yupResolver(schema),
  });

  const onFormSubmit = async (data) => {
    onSave(data.email);
    reset();
  };

  const onError = (data) => console.log(data);

  return (
    <FormDialog
      isOpen={isOpen}
      cancelButtonRef={cancelButtonRef}
      onClose={closeModal}
      title="Reset password"
      buttons={[
        { text: 'Send', type: 'submit', color: 'red' },
        { text: 'Cancel', onClick: closeModal, color: 'gray' },
      ]}
      onSubmit={handleSubmit(onFormSubmit, onError)}
      small
    >
      <div className="grid grid-cols-6 gap-6 text-left">
        <div className="col-span-6">
          <label htmlFor="email" className="block text-sm font-medium text-gray-700">
            Email
          </label>
          <div className="mt-1">
            <Input
              {...register('email')}
              className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
              name="email"
              id="email"
              type="email"
            />
          </div>
        </div>
      </div>
    </FormDialog>
  );
};
